import { render, staticRenderFns } from "./chat_details.vue?vue&type=template&id=ba2b15fa&"
import script from "./chat_details.vue?vue&type=script&lang=js&"
export * from "./chat_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports